<template>
    <div class="errPage-container">
        <el-button @click="back" icon='arrow-left' class="pan-back-btn">返回</el-button>
        <el-row>
            <el-col :span="12">
                <h1 class="text-jumbo text-ginormous">Oops!</h1>
                <!--gif来源<a href='https://zh.airbnb.com/' target='_blank'>airbnb</a> 页面-->
                <h2>你没有权限去该页面</h2>
                <h6>如有不满请联系你领导</h6>
                <ul class="list-unstyled">
                    <li>或者你可以去:</li>
                    <li class="link-type">
                        <!--<router-link to="/">回首页</router-link>-->
                        <el-button type="text" @click="logout">退出登录</el-button>
                    </li>
                </ul>
            </el-col>
            <el-col :span="12">
                <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream.">
            </el-col>
        </el-row>

        <el-dialog title="随便看" :visible.sync="dialogVisible" width="80%">
            <img class="pan-img" :src="ewizardClap">
        </el-dialog>
    </div>
</template>

<script>
import errGif from '@/assets/401_images/401.gif'
import store from '../../store'
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      errGif: errGif + '?' + +new Date(),
      ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'userLevel'
    ]),
    selfAreaId() {
      if (this.userLevel < 2) {
        return ''
      } else {
        return this.$store.getters.selfAreaId
      }
    }
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/' })
      } else {
        this.$router.go(-1)
      }
    },
    logout() {
      const vm = this
      // 获取用户登录设备
      const device = vm.getLoginDevice()
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        operationDevice: device,
        userName: vm.user.username,
        userId: vm.user.id
      }
      Api.logout(params, data)
        .then(res => {
          if (res.code === 200) {
            store.dispatch('user/logout')
              .then(() => {
                setTimeout(() => {
                  vm.$router.push('/login')
                }, 1000)
              })
          } else {
            vm.$message.warning(res.message)
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
    .errPage-container {
        width: 800px;
        margin: 100px auto;
        .pan-back-btn {
            background: #008489;
            color: #fff;
        }
        .pan-gif {
            margin: 0 auto;
            display: block;
        }
        .pan-img {
            display: block;
            margin: 0 auto;
        }
        .text-jumbo {
            font-size: 60px;
            font-weight: 700;
            color: #484848;
        }
        .list-unstyled {
            font-size: 14px;
            li {
                padding-bottom: 5px;
            }
            a {
                color: #008489;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
